import Profile from "@/pages/Profile";

export default function SettingsProfile() {
  return <Profile />;
}
